module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQElEQVQ4y2NgGBTgPxp4t27r/0uqFv/PCarhxTgNAIHvN27/f1zZQp4Bf798/X/NwmvUBSPcBe837yItJQ5tAABiba83DcUNnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BH.png
// module id = 1090
// module chunks = 0